import React, { useEffect, useState, useMemo } from "react";
import { Table, Badge, Button, Row, Col, Card } from "react-bootstrap";
import axios from "axios";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

import { useSelector } from "react-redux";
import RoomActionMenu from "./RoomActionMenu";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
export default function RoomCalendar() {

  const userData = useSelector((state) => state.authentication.userData);
  const API_BASE = `${process.env.REACT_APP_COLLEGE_ERP_API}`;

  const [rooms, setRooms] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [startDate, setStartDate] = useState(dayjs());
  const numberOfDays = 10;
  

  const dates = useMemo(() => {
    return Array.from({ length: numberOfDays }, (_, i) =>
      startDate.add(i, "day")
    );
  }, [startDate]);

  const fetchData = async () => {
    if (!userData?.branch || !userData?.token) return;

    const roomRes = await axios.get(
      `${API_BASE}rooms?branch=${userData.branch}`,
      {
        headers: { Authorization: `Bearer ${userData.token}` }
      }
    );

    const reservationRes = await axios.get(
      `${API_BASE}reservations?branch=${userData.branch}`,
      {
        headers: { Authorization: `Bearer ${userData.token}` }
      }
    );

    setRooms(roomRes.data || []);
    setReservations(reservationRes.data || []);
  };

  useEffect(() => {
    fetchData();
  }, [userData.token, userData.branch]);

  /* STATUS LOGIC */
const getStatusForDate = (room, date) => {
  const currentDate = dayjs(date).startOf("day");
   const roomReservations = reservationMap[room.roomNumber] || [];
  const booking = roomReservations.find((r) => {
    const checkIn = dayjs(r.checkInDate).startOf("day");
    const checkOut = dayjs(r.checkOutDate).startOf("day");

    const hasRoom = r.rooms?.some(
      (rm) => rm.roomNumber === room.roomNumber
    );

    return (
      hasRoom &&
      ["reserved", "confirmed", "checked-in"].includes(r.bookingStatus) &&
      currentDate.isSameOrAfter(checkIn) &&
      currentDate.isBefore(checkOut)
    );
  });

  return booking ? booking.bookingStatus : "vacant";
};

const getReservationForDate = (room, date) => {
  const currentDate = dayjs(date).startOf("day");
    const roomReservations = reservationMap[room.roomNumber] || [];
  return roomReservations.find((r) => {
    const checkIn = dayjs(r.checkInDate).startOf("day");
    const checkOut = dayjs(r.checkOutDate).startOf("day");

    const hasRoom = r.rooms?.some(
      (rm) => rm.roomNumber === room.roomNumber
    );

    return (
      hasRoom &&
      currentDate.isSameOrAfter(checkIn) &&
      currentDate.isBefore(checkOut)
    );
  });
};

const getColor = (status) => {
  switch (status) {
    case "reserved": return "warning";
    case "confirmed": return "info";
    case "checked-in": return "danger";
    case "checked_out": return "secondary";
    case "maintenance": return "dark";
    default: return "success"; // vacant
  }
};

const reservationMap = useMemo(() => {
  const map = {};

  reservations.forEach((r) => {
    r.rooms?.forEach((rm) => {
      if (!map[rm.roomNumber]) {
        map[rm.roomNumber] = [];
      }
      map[rm.roomNumber].push(r);
    });
  });

  return map;
}, [reservations]);

  /* NAVIGATION */

  const goPrev = () => setStartDate(prev => prev.subtract(numberOfDays, "day"));
  const goNext = () => setStartDate(prev => prev.add(numberOfDays, "day"));
  const goToday = () => setStartDate(dayjs());

  return (
    <div style={{ overflowX: "auto" }}>

      <Card className="mb-3 p-3">
        <Row className="align-items-center">
          <Col>
            <h5>
              {startDate.format("DD MMM YYYY")} -{" "}
              {startDate.add(numberOfDays - 1, "day").format("DD MMM YYYY")}
            </h5>
          </Col>

          <Col className="text-end">
            <Button size="sm" variant="secondary" onClick={goPrev}>◀</Button>{" "}
            <Button size="sm" variant="primary" onClick={goToday}>Today</Button>{" "}
            <Button size="sm" variant="secondary" onClick={goNext}>▶</Button>
          </Col>
        </Row>

        <div className="mt-2">
          <Badge bg="success">Vacant</Badge>{" "}
          <Badge bg="warning">Reserved</Badge>{" "}
          <Badge bg="info">Confirmed</Badge>{" "}
          <Badge bg="danger">Checked-In</Badge>{" "}
          <Badge bg="dark">Maintenance</Badge>
        </div>
      </Card>

    {/* Container with defined bounds and scrolling */}
<div style={{ maxHeight: "80vh", overflow: "auto" }}>
  <Table bordered hover>
    <thead>
      <tr>
        {/* Top-Left Corner (Sticky on top AND left) */}
        <th className="sticky-corner">Date</th>

        {/* Top Header Row (Sticky on top) */}
        {rooms.map((room) => (
          <th key={room.roomNumber} className="sticky-header">
            {room.roomNumber}
          </th>
        ))}
      </tr>
    </thead>

    <tbody>
      {dates.map((date, i) => (
        <tr key={i}>
          {/* First Column (Sticky on left) */}
          <td className="sticky-col">
            <strong>{date.format("DD MMM YYYY")}</strong>
          </td>

          {/* Regular Room Cells */}
          {rooms.map((room) => {
            const status = getStatusForDate(room, date);
            const reservation = getReservationForDate(room, date);

            return (
              <td key={room.roomNumber}>
                <div className="d-flex flex-column gap-1">
                  <Badge bg={getColor(status)}>
                    {status.replace("_", " ").toUpperCase()}
                  </Badge>

                  <RoomActionMenu
                   date={date}
                    room={room}
                    userData={userData}
                    API_BASE={API_BASE}
                    refreshRooms={fetchData}
                    reservation={reservation}
                  />
                </div>
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  </Table>
</div>

    </div>
  );
}